import { Box } from '@mantine/core';
import { ConfigFieldValue, DataInput } from '@/types/automationFields.ts';
import MultiDataInputSelectorUI from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelectorUI.tsx';
import { getInputContractDescription } from '@/pages/Editor/components/SharedFields/DataInputSelector/inputContractStatus.ts';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationDataInputMultiSelectConfigField } from '@/types/integrations.ts';
import { isConfiguredDataInput } from '@/pages/Editor/components/SharedFields/utils.ts';

type props = {
  stepId: string;
  field: IntegrationDataInputMultiSelectConfigField;
  fieldValue: DataInput[] | DataInput | null;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
};

const DataInputSelectField = ({ stepId, field, fieldValue, fieldValueConfig, onChange }: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);
  const dataInputs = (Array.isArray(fieldValue) ? fieldValue : fieldValue ? [fieldValue] : []).filter(
    isConfiguredDataInput,
  );

  return (
    <Box pos="relative">
      <MultiDataInputSelectorUI
        description={getInputContractDescription(field.description, field.input_contract)}
        placeholder={field.placeholder ?? undefined}
        dataInputs={dataInputs}
        stepId={stepId}
        updateDataInputs={(dataInputs: DataInput[]) => onChange(dataInputs)}
        error={error?.message}
        disabled={fieldValueConfig.is_disabled}
        label={field.display_name}
        required={field.required || field.input_contract?.required === true}
        inputContract={field.input_contract}
      />
    </Box>
  );
};

export default DataInputSelectField;
